import { aboutContent } from '@/mocks/homeData';

export default function AboutSection() {
  return (
    <section id="about" className="py-14 md:py-20 px-4 md:px-6 bg-background-100 scroll-mt-16">
      <div className="max-w-5xl mx-auto">
        <div className="grid grid-cols-1 lg:grid-cols-5 gap-8 lg:gap-12 items-center">
          <div className="lg:col-span-3">
            <span className="inline-block px-3 py-1 text-xs font-medium text-accent-700 bg-accent-100 rounded-full mb-3">平台介绍</span>
            <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950">关于我们</h2>
            {aboutContent.paragraphs.map((p, i) => (
              <p key={i} className="mt-4 text-sm text-foreground-700 leading-relaxed">{p}</p>
            ))}
          </div>
          <div className="lg:col-span-2">
            <div className="bg-background-50 border border-background-200/70 rounded-2xl p-6">
              <div className="grid grid-cols-3 gap-4">
                {aboutContent.stats.map((stat, i) => (
                  <div key={i} className="text-center">
                    <div className="font-heading text-2xl md:text-3xl font-bold text-primary-500">{stat.value}</div>
                    <div className="mt-1 text-xs text-foreground-500">{stat.label}</div>
                  </div>
                ))}
              </div>
              <div className="mt-6 pt-5 border-t border-background-200/70">
                <p className="text-xs text-foreground-600 leading-relaxed text-center">
                  黑料网站 - 真实即力量。我们坚持独立、客观的报道立场，为公众还原事件真相。
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}